import { bool, func, string } from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import FnrCheckbox from "UI/FnrEnrichedCheckbox/FnrCheckbox";

export default function InfoOption ({
  label,
  isChecked,
  onClick,
  loading,
  disabled,
  ...rest
}) {
  return (
    <CheckboxHolder
      disabled={disabled}
      onClick={() => onClick(!isChecked)}
      isChecked={isChecked}
      {...rest}
    >
      <FnrCheckbox on={isChecked} loading={loading} disabled={disabled}>
        <Text>{label}</Text>
      </FnrCheckbox>
    </CheckboxHolder>
  );
}

InfoOption.propTypes = {
  label: string.isRequired,
  isChecked: bool.isRequired,
  onClick: func.isRequired,
  loading: bool,
  disabled: bool,
};

const CheckboxHolder = styled.div``;

const Text = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #15436a;
`;